import { useState, useEffect, useCallback } from 'react';

const VALID_THEMES = ['dark', 'light'];

function getInitialTheme() {
  if (typeof window !== 'undefined') {
    try {
      const stored = localStorage.getItem('theme');
      if (stored && VALID_THEMES.includes(stored)) return stored;
    } catch {}
    try {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    } catch {}
  }
  return 'dark';
}

export function useTheme() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    const validTheme = VALID_THEMES.includes(theme) ? theme : 'dark';
    const root = document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(validTheme);
    try {
      localStorage.setItem('theme', validTheme);
    } catch {}
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, toggle };
}
